export default function(ngModule) {
    ngModule.factory('MetaData', function(BaseClass,$q, $http, $translate, $rootScope, $log) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function MetaData(attributes) {
            _.assign(this,attributes);
            var name = this.name;
            Object.defineProperty(this, 'name', {
                get: function() {
                    return name;
                },
                set: function(_name) {
                    return name = _name;
                },
                enumerable: true
            });
        }
        MetaData.modelName = 'MetaData';

        BaseClass.apply(MetaData);

        MetaData.configureAPIMessages({
            'POST /product/:product_guid/metaData/:guid': {
                406: 'models.product.notice.metaAlreadyAttached'
            },
            'DELETE /product/:product_guid/metaData/:guid': {
                406: 'models.product.notice.metaNotAttached'
            }
        });

        MetaData.validates({
            name: {
                required: true
            },
            type: {
                required: true,
                inclusion: {
                    in: ['integer','boolean','string','enum','values','seatSelect','date', 'enumOther']
                }
            },
            public: {
                format: {
                    boolean: true
                }
            },
            extra: { },
            applies_to: {
                inclusion: {
                    in: ['person', 'product']
                }
            },
            forced: {
                format: {
                    boolean: true
                }
            },
            default: {}
        });

        var proto = MetaData.prototype;
        proto.toString = function() { return this.name; };
        proto.$reinstate = () => $http.post(`/metaData/${this.guid}/reinstate`);

        // Workaround to provide translatable name and a pre-translated name for where $translate service is unavailable
        Object.defineProperty(proto, 'translateName', {
            get: function() { return this.public || this.translatable ? `common.metaData.${this.name}` : this.name; },
            set: function(v) { return v; },
            enumerable: false
        });
        Object.defineProperty(proto, 'translatedName', {
            get: function() { return this.public || this.translatable ? $translate.instant(this.translateName) : this.name; },
            set: function(v) { return v; },
            enumerable: false
        });

        MetaData.configureApi('/metaData/:guid', { queryAdmin: '/metaData/:status/:company', reinstate: '/metaData/:guid/reinstate' });
        MetaData.queryDeleted = function() {
            return $http.get('/metaData/trashed').then( result => {
                var models = _.map(result.body, MetaData.new);
                return $q.resolve(models);
            });
        };


        MetaData.belongsToMany('Product', 'products', '/product/^guid/metaData/:guid', [
            { type: 'query' },
            { type: 'attach' },
            { type: 'detach' }
        ]);

        return MetaData;
    });
}
